import { Controller } from "@hotwired/stimulus"

// busy === x.id / busy === `riconferma-${campo}` di pages/VerificaBandi.js: mentre una richiesta di una riga (segnalazione,
// dato da riconfermare) è in corso, tutti i pulsanti della riga sono disabilitati, non solo quello premuto; alla fine
// tornano come prima (quelli già disabilitati dal server restano disabilitati). I pulsanti con data-occupato-libero
// restano attivi (quelli che React non disabilitava con busy); i target `attesa` (la rotellina) si vedono solo durante
// la richiesta (busy di components/readiness/ModuloDomanda.js).
export default class extends Controller {
  static targets = ["attesa"]

  inizia() {
    this.disabilitati = [...this.element.querySelectorAll("button:not([disabled]):not([data-occupato-libero])")]
    this.disabilitati.forEach((b) => { b.disabled = true })
    this.attesaTargets.forEach((el) => { el.hidden = false })
  }

  fine() {
    ;(this.disabilitati || []).forEach((b) => { if (b.isConnected) b.disabled = false })
    this.disabilitati = []
    this.attesaTargets.forEach((el) => { el.hidden = true })
  }
}
